import reducer from "./reducer";
export { default as ConsentTypes } from "./components/index";
export { default as consentTypesReducerName } from "./constants";
export default reducer;
